import axios, { AxiosResponse } from "axios";

// Models
import { TradeUnionCaseRequest } from "../models/Requests/TradeUnionCaseRequest";
import { TradeUnionCaseResponse } from "../models/Responses/TradeUnionCaseResponse";
import { IsMrmResponse } from "../models/Responses/MRM";
import { ResumedMembershipPageContent } from "../models/Responses/ResumedMembershipPageContent";
import { ResumedMembershipCaseResponse } from "../models/Responses/ResumedMembershipCaseResponse";
import { PowerOfAttorneyCaseRequest } from "../models/Requests/PowerOfAttorneyCaseRequest";
import { FormResponse } from "../models/Responses/FormResponse";
import { PowerOfAttorneyPageContent } from "../models/Responses/PowerOfAttorneyPageContent";
import { ContactFormPageContent } from "../models/Responses/ContactFormPageContent";
import { ContactCaseRequest } from "../models/Requests/ContactCaseRequest";
import { RefundFormPageContent } from "../models/Responses/RefundFormPageContent";
import { RefundCaseRequest } from "../models/Requests/RefundCaseRequest";

const client = axios.create({
    baseURL: process.env.AEA_API_URL
});

type MrmResponse<T> = Promise<AxiosResponse<T>>;

export const createTradeUnionCase = (request: TradeUnionCaseRequest): MrmResponse<TradeUnionCaseResponse> => {
    return client.post<TradeUnionCaseResponse>('/umbraco/surface/formsurface/CreateMrmTradeUnionCase', request);
};

export const createResumedMembershipCase = (request: ResumedMembershipCaseRequest): MrmResponse<ResumedMembershipCaseResponse> => {
    return client.post<ResumedMembershipCaseResponse>('/umbraco/surface/formsurface/CreateResumedMembershipCase', request);
}

export const createPowerOfAttorneyCase = (request: PowerOfAttorneyCaseRequest): MrmResponse<FormResponse> => {
    return client.post<FormResponse>('/umbraco/surface/formsurface/CreatePowerOfAttorneyCase', request);
}

export const createContactCase = (request: ContactCaseRequest): MrmResponse<FormResponse> => {
    const formData = new FormData();

    if (request.attachment) {
        formData.append('attachment', request.attachment);
    }

    formData.append('data', JSON.stringify(request));
    return client.post<FormResponse>('/umbraco/surface/formsurface/CreateContactFormCase', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}

export const createRefundCase = (request: RefundCaseRequest): MrmResponse<FormResponse> => {
    return client.post<FormResponse>('/umbraco/surface/formsurface/CreateRefundFormCase', request);
}

export const getResumedMembershipPageData = (umbracoPageId: number): MrmResponse<ResumedMembershipPageContent> => {
    return client.get<ResumedMembershipPageContent>('/umbraco/surface/formsurface/GetResumedMembershipPageData', { params: { umbracoPageId: umbracoPageId } });
}

export const getPowerOfAttorneyPageData = (umbracoPageId: number): MrmResponse<PowerOfAttorneyPageContent> => {
    return client.get<PowerOfAttorneyPageContent>('/umbraco/surface/formsurface/GetPowerOfAttorneyPageData', { params: { umbracoPageId: umbracoPageId } });
}

export const getContactFormPageData = (umbracoPageId: number): MrmResponse<ContactFormPageContent> => {
    return client.get<ContactFormPageContent>('/umbraco/surface/formsurface/GetContactFormPageData', { params: { umbracoPageId: umbracoPageId } });
}

export const getRefundFormPageData = (umbracoPageId: number): MrmResponse<RefundFormPageContent> => {
    return client.get<RefundFormPageContent>('/umbraco/surface/formsurface/GetRefundFormPageData', { params: { umbracoPageId: umbracoPageId } });
}

export const isMrmProduction = () => {
    var url = '/umbraco/surface/formsurface/IsMrmProduction';
    return client.get<IsMrmResponse>(url);
}